import { createAction } from '@reduxjs/toolkit';

export const youtubeUpdateId = createAction('youtube/updateId');
export const youtubeUpdateUID = createAction('youtube/updateUid');
export const youtubeUpdateSID = createAction('youtube/updateSid');
export const youtubeUpdateIsAdded = createAction('youtube/updateIsAdded');
export const youtubeUpdateIsActive = createAction('youtube/updateIsActive');

export const youtubeStore = createAction('youtube/store');
export const youtubeClear = createAction('youtube/clear');

export const youtubeUpdateRequest = createAction('youtube/updateRequest');
export const youtubeUpdateError = createAction('youtube/updateError');
export const youtubeUpdateStore = createAction('youtube/updateStore');

export const youtubeUpdateItems = createAction('youtube/updateItems');
export const youtubeUpdateLists = createAction('youtube/updateLists');

export const youtubeUpdateConnect = createAction('youtube/updateConnect');
export const youtubeUpdateLayout = createAction('youtube/updateLayout');
export const youtubeUpdateView = createAction('youtube/updateView');

export const youtubeUpdateHeadingTitle = createAction('youtube/updateHeadingTitle');
export const youtubeUpdateHeadingDescription = createAction('youtube/updateHeadingDescription');
export const youtubeUpdateHeadingTextAlign = createAction('youtube/updateHeadingTextAlign');
export const youtubeUpdateHeadingImage = createAction('youtube/updateHeadingImage');
export const youtubeUpdateHeadingDivider = createAction('youtube/updateHeadingDivider');

export const youtubeUpdateSectionIsBackground = createAction('youtube/updateSectionIsBackground');
export const youtubeUpdateSectionTextColor = createAction('youtube/updateSectionTextColor');
export const youtubeUpdateSectionBackgroundColor = createAction('youtube/updateSectionBackgroundColor');
export const youtubeUpdateSectionOpacity = createAction('youtube/updateSectionOpacity');
export const youtubeUpdateSectionIsFullWidth = createAction('youtube/updateSectionIsFullWidth');
export const youtubeUpdateSectionShadow = createAction('youtube/updateSectionShadow');
export const youtubeUpdateSectionShadowColor = createAction('youtube/updateSectionShadowColor');
export const youtubeUpdateSectionPadding = createAction('youtube/updateSectionPadding');
export const youtubeUpdateSectionMargin = createAction('youtube/updateSectionMargin');
export const youtubeUpdateSectionBackgroundType = createAction('youtube/updateSectionBackgroundType');
export const youtubeUpdateSectionBackgroundImage = createAction('youtube/updateSectionBackgroundImage');
export const youtubeUpdateSectionGradientColor1 = createAction('youtube/updateSectionGradientColor1');
export const youtubeUpdateSectionGradientColor2 = createAction('youtube/updateSectionGradientColor2');
export const youtubeUpdateSectionGradientDirection = createAction('youtube/updateSectionGradientDirection');
export const youtubeUpdateSectionGradientOffset = createAction('youtube/updateSectionGradientOffset');
export const youtubeUpdateSectionBorder = createAction('youtube/updateSectionBorder');
export const youtubeUpdateSectionBorderColor = createAction('youtube/updateSectionBorderColor');
export const youtubeUpdateSectionShadowBorderColor = createAction('youtube/updateSectionShadowBorderColor');
export const youtubeUpdateSectionShape = createAction('youtube/updateSectionShape');
